import axios from '@/api/axios'

export interface CallbackReminderConfig {
  user_id: number
  user_name: string | null
  user_email: string
  minutes_before: number
  show_phone: boolean
  show_campaign: boolean
  show_time: boolean
  show_reason: boolean
  show_operator: boolean
  show_codificacion: boolean
  is_enabled: boolean
  updated_at: string | null
}

export interface CallbackReminderLog {
  id: number
  schedule_history_id: number
  user_id: number
  user_name: string | null
  lead_id: number
  lead_name: string | null
  scheduled_date: string | null
  scheduled_time: string | null
  sent_at: string
  action: string
  action_at: string | null
}

export const callbackRemindersApi = {
  async getConfigs(): Promise<{ items: CallbackReminderConfig[]; total: number }> {
    const { data } = await axios.get('/api/v1/callback-reminders/config')
    return data
  },

  async getConfig(userId: number): Promise<CallbackReminderConfig> {
    const { data } = await axios.get(`/api/v1/callback-reminders/config/${userId}`)
    return data
  },

  async saveConfig(userId: number, config: Partial<CallbackReminderConfig>): Promise<CallbackReminderConfig> {
    const { data } = await axios.put(`/api/v1/callback-reminders/config/${userId}`, config)
    return data
  },

  async getLogs(params: {
    user_id?: number
    lead_id?: number
    action?: string
    from_date?: string
    to_date?: string
    page?: number
    page_size?: number
  }): Promise<{ items: CallbackReminderLog[]; total: number; page: number; page_size: number }> {
    const { data } = await axios.get('/api/v1/callback-reminders/log', { params })
    return data
  },

  async reportAction(logId: number, action: string): Promise<CallbackReminderLog> {
    const { data } = await axios.post(`/api/v1/callback-reminders/log/${logId}/action`, { action })
    return data
  },
}
